import React from "react";
import { objectOf, string } from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";

const styles = {
    root: {
        flexGrow: 1
    }
};

const LinearIndeterminate = (props) => {
    const { classes } = props;
    return (
        <div className={classes.root}>
            <LinearProgress/>
        </div>
    );
};

LinearIndeterminate.propTypes = {
    classes: objectOf(string).isRequired
};

export default withStyles(styles)(LinearIndeterminate);
